export const MAX_PROFILE_QUESTIONS = 30;

export const EXPERIENCE_LEVEL_OPTIONS = [
  { value: 'entry', label: 'Entry Level (0-1 yrs)' },
  { value: 'junior', label: 'Junior (1-3 yrs)' },
  { value: 'mid', label: 'Mid Level (3-5 yrs)' },
  { value: 'senior', label: 'Senior (5-8 yrs)' },
  { value: 'lead', label: 'Lead (8+ yrs)' },
  { value: 'executive', label: 'Executive (10+ yrs)' },
];

export const getExperienceLevelBadge = (level) => getExperienceLevelLabel(level);

export const getExperienceLevelLabel = (level) => {
  const found = EXPERIENCE_LEVEL_OPTIONS.find((opt) => opt.value === level);
  return found ? found.label : level || 'Not Specified';
};

export const getExperienceLevelColor = (level) => {
  const colors = {
    entry: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    junior: 'bg-blue-50 text-blue-700 border-blue-200',
    mid: 'bg-indigo-50 text-indigo-700 border-indigo-200',
    senior: 'bg-purple-50 text-purple-700 border-purple-200',
    lead: 'bg-amber-50 text-amber-800 border-amber-200',
    executive: 'bg-rose-50 text-rose-700 border-rose-200',
  };
  return colors[level] || 'bg-gray-100 text-gray-700 border-gray-200';
};

export const getCategoryBreakdown = (questions = []) => {
  const breakdown = {
    concept: 0,
    coding: 0,
    mcq: 0,
    behavioral: 0,
    general: 0,
  };
  if (!Array.isArray(questions)) return breakdown;

  questions.forEach((q) => {
    const type = (q.question_type || q.type || 'concept').toLowerCase();
    if (breakdown[type] !== undefined) {
      breakdown[type] += 1;
    } else {
      breakdown.general += 1;
    }
  });

  return breakdown;
};

export const profileQuestionToJdQuestion = (q, userDetails = null, profileName = null) => {
  const jdQuestion = {
    nameOfQuestion: q.text || q.nameOfQuestion || '',
    type: q.question_type || q.type || 'concept',
    profileId: q.profile || q.profileId,
    profileQuestionId: q.id || q.profileQuestionId,
    profileName: profileName || q.profileName || q.profile_name || '',
    createdAt: new Date().toISOString(),
    createdBy: userDetails?.id || null,
    skillTag: q.skill_tag || q.skillTag || '',
    difficulty: q.difficulty || null,
  };

  if (jdQuestion.type === 'coding') {
    const rawLimit = q.time_limit ?? q.timeLimit;
    const limit = Number(rawLimit) > 0 ? Number(rawLimit) : 5;
    jdQuestion.time_limit = limit;
    jdQuestion.timeLimit = limit;
  }

  if (jdQuestion.type === 'mcq') {
    const rawChoices = Array.isArray(q.choices) ? q.choices : [];
    jdQuestion.choices = rawChoices.map((c) => ({
      text: typeof c === 'string' ? c : c?.text || '',
      is_correct: Boolean(c?.is_correct || c?.correct),
    }));
  }

  if (q.company_question || q.questionBankId) {
    jdQuestion.questionBankId = q.company_question || q.questionBankId;
  }

  return jdQuestion;
};

